import Common from '@/utils/saas/common' // 工具类

// 提现页面初始化
export function initWithdraw(data) {
  return Common.createRequest('trade-api', 'CUSTOMER_105', data, '提现初始化')
}

// 提现提交
export function submitWithdraw(data) {
  return Common.createRequest('trade-api', 'CUSTOMER_101', data, '提现提交')
}

